import React from "react";
import ContentListPage from "@/components/ContentListPage";

export default function Articles() {
  return (
    <ContentListPage
      type="article"
      routeBase="/articles"
      eyebrow="Articles & Publications"
      title={<>Peer-reviewed <span className="italic text-[#E07A5F]">clinical writing</span>.</>}
      subtitle="Selected articles, journal publications and expert commentary from our doctors — including work published in the Annals of Indian Psychiatry and the Journal of Psychosexual Health."
      seoTitle="Articles & Publications — Peer-reviewed Clinical Writing"
      seoDescription="Peer-reviewed articles and journal publications from Manas Neuropsychiatry Hospital, Bhavnagar. Featured in Annals of Indian Psychiatry, Journal of Psychosexual Health and more."
      testIdPrefix="article"
    />
  );
}
